<script setup lang="ts">

import { reactive, computed, ref } from "vue";
import { useRouter,useRoute } from "vue-router";
import axios from 'axios'
import { loginType } from "../utils/types";
import { loginMeths } from "../utils/admin";
import AxiosUserService from "../utils/axiosUserService";
import { useLanguage } from "../utils/useLanguage";

const { t } = useLanguage();


const axiosUserService = new AxiosUserService();

// Google Auth
const authGoogle = () => {

  axiosUserService.google_authorize_login()
  .then(function (res) {
    // location.reload()
    let auth_url = res.data.authorization_url
    window.location.href = auth_url
    // console.log(res.data.authorization_url)
  }).catch(function (res) {
    console.log(res.data)
  })
}


const inputValid = reactive({
    email: false,
    password: false,
    emailError: "",
    pwdError: "Password is incorrect.",
})

const loginUser = ref<loginType>({
    username: "",
    password: ""
})

const router= useRouter();
const route= useRoute();
const pastUrl = ref<string | null>(null);


// 确保 pastUrl 的值不为 null
if (typeof router.options.history.state.back === 'string') {
  pastUrl.value = router.options.history.state.back;
}

const urlPath = ref(pastUrl.value ? pastUrl.value as string : '')


const isAdminLoginRoute = computed(() => {
  return urlPath.value.startsWith('/admin/login')

})

const login = () => {

    const params = new URLSearchParams();
    params.append('username', loginUser.value.username);
    params.append('password', loginUser.value.password);

    inputValid.email = false;
    inputValid.password = false;

    if(loginUser.value.username == ""){
        inputValid.email = true;
        inputValid.emailError = "Email cannot be empty."
    }else if(loginUser.value.password == ""){
        inputValid.password = true;
        inputValid.pwdError = "Password cannot be empty."
    }else{
         loginMeths.post("/api/v1/user/login", params).then(function (res) {
    
            let token = res.data.access_token    
    
            localStorage.setItem("token", token)

            location.reload()
            

        }).catch(function (res) {
            console.log(res)
    
            let error_stat = res.response.status
            if(error_stat == 400){
                
                inputValid.email = true;
                inputValid.emailError = "User email or Password is incorrect."
                inputValid.password = true;
                inputValid.pwdError = "User email or Password is incorrect."

            }else if(error_stat == 422){
                
                inputValid.password = true;
                inputValid.pwdError = "Password is incorrect."
            }
        })
    }
}

const showPwd  = (event: Event,id: any) => {
    let pwdInput: any = document.getElementById(id) 
    let type = pwdInput.type 
    if(type == 'password'){
        (event.target as HTMLInputElement).src = '/icon-open.png'
        pwdInput.type = 'text'
        
    }else{
        (event.target as HTMLInputElement).src = '/icon-close.png'
        pwdInput.type = 'password'
    }
    
}
</script>
<template>

<div class="adminBox fixed p-center flex column a-center br-20 scroll" style="background-color: #f0dde3;">
  <a href="/">
    <img src="/logo_2024_black.png" alt="logo" />
  </a>

  <div class="flex column p-40 p-md-20" style="max-width: 450px; width: 100%; margin: 0 auto;">
    <label class="label">{{ t('Account') }} <span class="bold" style="color: #d81f5b;">*</span></label>
    <input
      id="email"
      class="input"
      :class="inputValid.email ? 'error' : ''"
      :placeholder="t('Your email')"
      type="email"
      v-model="loginUser.username"
    />
    <p class="dark bold" v-if="inputValid.email">{{ inputValid.emailError }}</p>

    <label class="label">{{ t('Password') }} <span class="bold" style="color: #d81f5b;">*</span></label>
    <input
      id="password"
      class="input"
      :class="inputValid.password ? 'error' : ''"
      :placeholder="t('Password')"
      type="password"
      v-model="loginUser.password"
    />
    <p class="dark bold" v-if="inputValid.password">{{ inputValid.pwdError }}</p>

    <div class="mt-20">
      <div class="btn full capsule bg-dark white-1 mb-10" @click="login" v-t="'Login'"></div>
      <div class="btn full capsule outline br-dark dark" @click="authGoogle">
        <img src="/icon-google.png" alt="google icon" class="s-20" />
        {{ t('Sign in with Google') }}
      </div>
    </div>
  </div>

  <p class="font-3 mt-20 buttom_text">
    <router-link to="/admin/forget-password">{{ t('Forgot Password?') }}</router-link> |
    <router-link to="/admin/register" style="color: #d81f5b;">{{ t('Create account') }}</router-link>
  </p>
</div>


</template>

<style scoped>
@import '../assets/css_lib/themimir.css';
.adminBox{
    width: 600px;
    height: 600px;
    padding: 80px 0;
    max-width: 90vw;
    max-height: 90vh;

}
</style>